import BaseAPI from '../base'

function getCurrent(source) {
    return BaseAPI.get(`compatibility/current`, {
        source
    });
}

function check(source, version) {
    return BaseAPI.get(`compatibility/check`, {
        source,
        version
    });
}

export default {
    getCurrent,
    check
}